import React from 'react';


import SimpleModal from "../../shared/SimpleModal";

function DocumentPreview({
    onSelect,
    file,
}) {

    const isAudio = file?.fileType?.includes('audio');

    const closeModal = () => {
        onSelect({}, false);
    };

    const getUrl = () => {
        const officeTypes = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/msword',
            'application/vnd.ms-word.document.macroEnabled.12',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
            'application/vnd.ms-excel',
            'application/vnd.ms-excel.sheet.macroEnabled.12',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-powerpoint',
            'text/csv'
        ];
        
        return officeTypes.includes(file.fileType)
            ? 'https://view.officeapps.live.com/op/embed.aspx?src=' + file.url
            : file.url;
    };

    return (
        <SimpleModal
            open={file.show}
            onClose={closeModal}
            title="Visualizar Arquivo"
            maxWidth="xl"
            style={{
                height: '100%',
            }}
            bodyStyle={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            {isAudio && !!file?.audioTranscription && (
                <div className="text-base text-gray-700 mb-4">
                    <b>Transcrição:</b> {file.audioTranscription}
                </div>
            )}
            <div className="flex-1">
                <iframe src={getUrl()} width='100%' height='100%' style={{ border: 'none' }} />
            </div>
        </SimpleModal>
    );
}

export default DocumentPreview;
